    <template>
     <div class="bg-pink-lighter  h-full lg:h-64 text-center lg:text-justify">
         <div class="block w-full h-full">
         <div class="lg:float-left block mt-5  lg:ml-12 w-full lg:w-1/2">
            <p class="text-xl lg:text-2xl mt-8 font-bold text-lg mb-2"> Signup For Our NewsLetter</p>
            <p class="text-sm font-medium text-lg mb-2"> Keep up do date with the latest property deals</p>
            <input type="emailModel.email" v-model="emailModel.email" class="border border-black w-full  lg:w-1/2  text-center" style="height:34px" placeholder="Enter your email">
            <button @click="subscribeEmail" class="w-32 bg-black mt-2 lg:ml-2 border border-black w-full lg:w-1/5  text-white font-medium" style="height:34.5px" >Subscribe</button>
            <p class="text-sm font-medium text-sm mb-2"> {{genMsg}} </p>

         </div>
         <div class="lg:float-right block text-center mt-2 lg:mt-32">
              <router-link to="/policy" class="mr-4 text-md md:text-xl hover:border-b-4 hover:border-black" >Private Policy</router-link>
              <router-link to="/about"  class="mr-4 text-md md:text-xl hover:border-b-4 hover:border-black" >About us</router-link>
              <router-link to="/terms"  class="mr-4 text-md md:text-xl hover:border-b-4 hover:border-black" >Terms of use</router-link>
        </div>
            </div>

                <div class="block bg-pink-lighter m-auto text-xl w-full text-sm pb-2 font-black text-lg   text-center">
                    © 2020 by HomeDeals
                </div>
        </div>

</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  head() {
    return {
      title: {
        inner: 'Home',
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc',
        },
      ],
    };
  },
  data() {
    return {
      isOpen: false,
      type: [
        { name: 'illness', selected: false },
        { name: 'contraceptive', selected: false },
        { name: 'other', selected: false },
      ],
      selectedType: 'illness',
      selected: 'illness',
      subscribed: false,
      footerMsg: '',
      errSub: false,
      emailModel: { email: '' },
      options: [
        { text: 'illness', value: 'illness' },
        { text: 'contraceptive', value: 'contraceptive' },
        { text: 'other', value: 'other' },
      ],
      restOfCities: [],
      openBox: false,
    };
  },
  computed: {
    ...mapState('app', ['appTitle']),
    ...mapState('search', ['dropdownMainSelected', 'setDropdownSubCatIndex', 'subCatInfo', 'latestkitlist', 'dropdownIndex', 'mainOptions', 'propertylist', 'MainOptionSelected', 'SelectedOption']),
    ...mapState('dropdown', ['dropdownMainSelected', 'dropdownOptions', 'dropdownIndex']),
    ...mapGetters('dropdown', ['getDropdown']),
    genMsg: {
      get() {
        return this.footerMsg;
      },
    },
  },
  methods: {
    ...mapActions('search', ['getSelectedSubcat', 'subscribe']),
    populateCities(event) {
      console.log(this.$refs.input);
      event.preventDefault();
      this.openBox = true;
      this.restOfCities = [
        { name: 'Montreal', selected: false },
        { name: 'Vancouver', selected: false },
        { name: 'Toronto', selected: false },
        { name: 'Calgary', selected: false },
      ];
      _.remove(this.restOfCities, this.selected);
    },
    subscribeEmail() {
      if (!this.validEmail(this.emailModel.email)) {
        this.footerMsg = 'Please enter a valid email.';
      } else if (this.emailModel.email.length === 0) {
        this.footerMsg = 'Please enter your email.';
      } else {
        this.subscribe(this.emailModel);
        this.footerMsg = 'Thank you for Subscribing! Check your email soon for updates!';
      }
    },
    validEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    setCity(name, event) {
      event.preventDefault();
      this.selected = name;
      _.remove(this.restOfCities, { name, selected: false });
      this.restOfCities = [];
      this.openBox = false;
    },
    setType(type, event) {
      event.preventDefault();
      this.selectedType = type.name;
    },
    loadSelect(name, event) {
      event.preventDefault();
      console.log(name);
      this.selectedType = name;
    },
    search(name, event) {
      event.preventDefault();
    },
    handleBlur() {
      this.restOfCities = this.selected;
      console.log('blur2!!');
    },
    away() {
      this.restOfCities = [];
    },
  },
  async mounted() {
    this.getSelectedSubcat();
  },
};
</script>
